import { PinsCounter } from './PinsCounter';

export function InlinePinsCounter() {
  return <PinsCounter />;
}
